// extracted by mini-css-extract-plugin
module.exports = {"list":"StringList_list_1D1hd","label":"StringList_label_3my39","item":"StringList_item_3QT8D"};